module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/jpg-5ffbc9bc9f69b085db3617e229ce4479.svg";